import * as React from "react";
import { SVGProps, memo } from "react";

const SvgPillPinSm = (props: SVGProps<SVGSVGElement>) => (
  <svg width={32} height={37} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#PillPinSm_svg__a)">
      <mask id="PillPinSm_svg__b" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.692.691A3.692 3.692 0 0 0 4 4.384v16.615a3.692 3.692 0 0 0 3.692 3.692h5.643L16 29.307l2.665-4.616h5.643A3.692 3.692 0 0 0 28 21V4.384A3.692 3.692 0 0 0 24.308.69H7.692Z"
        />
      </mask>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.692.691A3.692 3.692 0 0 0 4 4.384v16.615a3.692 3.692 0 0 0 3.692 3.692h5.643L16 29.307l2.665-4.616h5.643A3.692 3.692 0 0 0 28 21V4.384A3.692 3.692 0 0 0 24.308.69H7.692Z"
        fill="#26734C"
      />

      <path
        d="m13.335 24.691.4-.23-.133-.231h-.267v.461ZM16 29.307l-.4.23.4.693.4-.692-.4-.231Zm2.665-4.616v-.461h-.267l-.133.23.4.231ZM4.462 4.384a3.23 3.23 0 0 1 3.23-3.231V.23a4.154 4.154 0 0 0-4.154 4.154h.924Zm0 16.615V4.384h-.924v16.615h.924Zm3.23 3.23A3.23 3.23 0 0 1 4.462 21h-.924a4.154 4.154 0 0 0 4.154 4.154v-.923Zm5.643 0H7.692v.924h5.643v-.923Zm3.065 4.847-2.665-4.615-.8.461 2.665 4.616.8-.462Zm1.865-4.615L15.6 29.076l.8.462 2.664-4.616-.799-.461Zm6.043-.231h-5.643v.923h5.643v-.923Zm3.23-3.23a3.23 3.23 0 0 1-3.23 3.23v.923a4.154 4.154 0 0 0 4.154-4.154h-.924Zm0-16.616v16.615h.924V4.384h-.924Zm-3.23-3.231a3.23 3.23 0 0 1 3.23 3.23h.924A4.154 4.154 0 0 0 24.308.23v.923Zm-16.616 0h16.616V.23H7.692v.923Z"
        fill="#194D33"
        mask="url(#PillPinSm_svg__b)"
      />
    </g>

    <path
      d="M13.923 18.23c-.964 0-1.782-.336-2.454-1.007-.672-.672-1.008-1.49-1.008-2.454a3.42 3.42 0 0 1 1.016-2.446l4.154-4.154a3.437 3.437 0 0 1 2.446-1.016c.964 0 1.782.336 2.454 1.008.672.672 1.007 1.49 1.007 2.454a3.42 3.42 0 0 1-1.015 2.446l-4.154 4.154a3.437 3.437 0 0 1-2.446 1.015Zm0-.923c.328 0 .651-.064.97-.192.317-.128.594-.31.83-.546l2.046-2.062-3.584-3.584-2.062 2.046a2.552 2.552 0 0 0-.739 1.8c0 .707.247 1.307.739 1.8a2.45 2.45 0 0 0 1.8.738Z"
      fill="#fff"
    />

    <defs>
      <filter
        id="PillPinSm_svg__a"
        x={0.308}
        y={0.691}
        width={31.385}
        height={36}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />

        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />

        <feOffset dy={3.692} />

        <feGaussianBlur stdDeviation={1.846} />

        <feComposite in2="hardAlpha" operator="out" />

        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />

        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_24384_56696" />

        <feBlend in="SourceGraphic" in2="effect1_dropShadow_24384_56696" result="shape" />
      </filter>
    </defs>
  </svg>
);

const Memo = memo(SvgPillPinSm);

export default Memo;
